import gsap, { Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


$(window).on('load', function() {

	let scroll_width = $('.contacts-header .right-col').outerWidth() * 0.8

	gsap.fromTo('.contacts-header .plane',
	  { x: 0 },
	  {
	    x: scroll_width,
	    ease: 'none',
	    scrollTrigger: {
	      trigger: '.contacts-header .right-col',
	      start: 'top top',
	      end: 'bottom top',
	      scrub: true
	    }
	  }
	);

})